<template>
  <div :class="['mobile-multiselect-item', { 'mobile-multiselect-item_selected' : isSelected }]">
    <div class="mobile-multiselect-item__title">
      {{ title }}
    </div>
    <div class="mobile-multiselect-item__value">
      <slot>
        <div
          v-if="isSelected"
          class="mobile-multiselect-item__default-icon"
        >
          <f-sprite-icon :icon-link="$options.icons.IconCheck.id" />
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import IconCheck from '@icons/check.svg';

export default {
  icons: {
    IconCheck
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss">
  .mobile-multiselect-item {
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $gray_lu;
    cursor: pointer;
    align-items: center;

    &_selected {
      background: $gray_bgr;
    }

    &__title {
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }

    &__default-icon {
      svg {
        width: 16px;
        height: 16px;
        color: $blue;
      }
    }
  }
</style>